import { $ } from '@zimpa/dom';
import { Template } from "../template";
import { Modal } from "../modal/modal";
import { quickScan } from "../modules/quickscan/quickscan";

const SOLO_SELECTOR = '.js-request-steps__solo';
const SHARE_SELECTOR = '.js-request-steps__share';

const MODAL_TEMPLATE_SELECTOR = '#quickscan-modal';

const CLICK_EVENT = 'click';

export function requestSteps(): void {
    const solo = $<HTMLButtonElement>(SOLO_SELECTOR);
    const share = $<HTMLButtonElement>(SHARE_SELECTOR);

    if (solo !== undefined) {
        solo.addEventListener(CLICK_EVENT, (e): void => {
            e.preventDefault();

            const tpl = $(MODAL_TEMPLATE_SELECTOR);

            if (tpl === undefined) {
                return;
            }

            const template = new Template(tpl.innerHTML);
            const content = template.render({});

            Modal.open(content);

            quickScan();
        });
    }

    if (share !== undefined) {
        share.addEventListener(CLICK_EVENT, (e): void => {
            e.preventDefault();

            const tpl = $(MODAL_TEMPLATE_SELECTOR);

            if (tpl === undefined) {
                return;
            }

            const template = new Template(tpl.innerHTML);
            const content = template.render({});

            Modal.open(content);

            quickScan();
        });
    }

}
